import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./DonutChart.css";

export default function DonutChart({
  dataPoints,
  innerRadius,
  width,
  height,
  fontSize,
  hideLabel,
  size,
}) {
  const w = width ?? 500;
  const h = height ?? 400;
  const ir = innerRadius ?? 65;
  const fs = fontSize ?? 10;
  const si = size ?? "80%";

  const seriesData = useMemo(
    () =>
      (dataPoints || []).map((d) => ({
        y: d?.y ?? d?.value ?? 0,
        name: d?.label ?? d?.name ?? "",
        color: d?.color,
      })),
    [dataPoints]
  );

const options = {
  chart: {
    type: "pie",
    backgroundColor: "transparent",
    width: w,
    height: h,
    animation: false,
    spacing: [10, 40, 60, 40],
  },
  title: { text: null },
  credits: { enabled: false },
  tooltip: { enabled: false },
  legend: { enabled: false },

  plotOptions: {
    pie: {
      startAngle: 270,
      borderWidth: 0,
      size: `${si}%`,           
      innerSize: `${ir}%`, 
      center: ["50%", "70%"],
      allowPointSelect: false,

      dataLabels: {
        enabled: !hideLabel,
        formatter: function () {
          const name = this.point?.name ?? "";
          const pct = Math.round(this.percentage || 0);
          return `${name} - ${pct}%`;
        },
        style: { fontSize: `${fs}px`, textOutline: "none" },
        distance: 10,
        softConnector: true,
        connectorPadding: 4,
        connectorWidth: 1,
        crop: false,          
        overflow: "justify", 
      },
    },
  },

  series: [{ type: "pie", data: seriesData }],
};

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
